// import React, { useState, useMemo } from 'react';
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Stack,
//   useTheme,
//   FormControl,
//   Select,
//   MenuItem,
//   SelectChangeEvent,
//   IconButton,
// } from '@mui/material';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


// export interface BreakdownRow {
//   group: string;
//   cost: number;
//   credits: number;
//   discount: number;
//   usage: string;
//   totalCost: number;
// }

// export interface CostBreakdownTableProps {
//   breakdown: BreakdownRow[];
//   groupBy: string; // e.g., "Services", "Project ID"
//   colorMap: { [key: string]: string };
// }

// const CostBreakdownTable: React.FC<CostBreakdownTableProps> = ({ breakdown, groupBy, colorMap }) => {
//   const theme = useTheme();

//   // Determine if the 'Usage' column should be displayed based on the groupBy value.
//   const showUsageColumn = !['Region', 'Data Sources', 'Project','Services'].includes(groupBy);

//   // --- PAGINATION STATE ---
//   const [page, setPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page

//   // --- PAGINATION LOGIC ---
//   const pageCount = Math.ceil(breakdown.length / rowsPerPage);
//   const paginatedData = useMemo(() => {
//     const startIndex = (page - 1) * rowsPerPage;
//     return breakdown.slice(startIndex, startIndex + rowsPerPage);
//   }, [breakdown, page, rowsPerPage]);
//   const showingFrom = breakdown.length > 0 ? (page - 1) * rowsPerPage + 1 : 0;
//   const showingTo = Math.min(page * rowsPerPage, breakdown.length);

//   const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
//     setRowsPerPage(event.target.value as number);
//     setPage(1); // Reset to the first page when rows per page changes
//   };

//   return (
//       <Paper sx={{
//         py: 2,
//         borderRadius: '16px',
//         boxShadow: 'none',
//         display: 'flex',
//         flexDirection: 'column',
//         height: '100%'
//       }}>
//         <Typography variant="h6" sx={{
//           mb: 2,
//           mt: 3,
//           ml:1,
//           fontWeight: 550,
//           fontFamily: 'Inter',
//           px: 2,
//           flexShrink: 0,
//           fontSize: '16px',
//           fontweight:600
//         }}>
//           Cost Breakdown
//         </Typography>

//         <TableContainer sx={{
//           flexGrow: 1,
//           overflow: 'auto'
//         }}>
//           <Table
//             sx={{
//               width: '100%',
//               tableLayout: 'fixed',
//               '& .MuiTableCell-root': {
//                 borderBottom: 'none',
//                 fontFamily: 'Inter',
//                 py: '16px',
//                 px: '20px'
//               }
//             }}
//           >
//             <TableHead>
//               <TableRow>
//                 {/* In the <TableHead> section...
//                     REPLACE this line:
//                     <TableCell sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Service</TableCell>
//                     WITH this: */}
//                 <TableCell sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>{groupBy}</TableCell>
//                 <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Cost</TableCell>
//                 <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Credits</TableCell>
//                 <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Discount</TableCell>
//                 {showUsageColumn && (
//                   <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Usage</TableCell>
//                 )}
//                 <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Total Cost</TableCell>
//                 <TableCell sx={{ width: '24px', padding: 0 }} />
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {/* In the <TableBody> section...
//                   REPLACE the entire `paginatedData.map(...)` block with this new one.
//                   We are keeping the structure but populating with real data and placeholders. */}
//               {paginatedData.map((row, index) => (
//                 <TableRow
//                   key={`${row.group}-${index}`} // Use a more robust key
//                   sx={{
//                     '&:last-child td, &:last-child th': { border: 0 },
//                     '&:nth-of-type(odd)': {
//                         backgroundColor: '#F9FAFB',
//                     },
//                   }}
//                 >
//                   <TableCell>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colorMap[row.group] || '#667085', flexShrink: 0 }} />
//                         <Typography variant="body2" sx={{fontFamily: 'Inter', pl: '8px'}}>{row.group}</Typography>
//                     </Stack>
//                   </TableCell>
//                   <TableCell align="right">
//                     ${row.cost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
//                   </TableCell>
//                   <TableCell align="right">${row.credits.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>

//                   <TableCell align="right">
//                     ${row.discount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
//                   </TableCell>
//                   {showUsageColumn && (
//                     <TableCell align="right">{row.usage}</TableCell>
//                   )}
//                   <TableCell align="right">
//                     ${row.totalCost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
//                   </TableCell>
//                   <TableCell sx={{ padding: 0 }}/>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* --- PAGINATION SECTION (Styling applied) --- */}
//         <Box sx={{
//           flexShrink: 0,
//           mt: 1,
//           mb: 0,
//           display: 'flex',
//           justifyContent: 'flex-end',
//           alignItems: 'center',
//           gap: 2,
//           minHeight: '3.5rem',
//           padding: '0 1.5rem',
//           backgroundColor: '#FFFFFF',
//         }}>
//             <Typography sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary'  }}>
//                 Rows per page:
//             </Typography>
//             <FormControl size="small">
//                 <Select
//                     value={rowsPerPage}
//                     onChange={handleRowsPerPageChange}
//                     sx={{
//                         fontFamily: 'Inter',
//                         fontSize: '0.875rem',
//                         color: 'text.secondary',
//                         '.MuiOutlinedInput-notchedOutline': { border: 'none' },
//                         '.MuiSelect-select': { padding: '4px 8px' },
//                     }}
//                 >
//                     <MenuItem value={5}>5</MenuItem>
//                     <MenuItem value={10}>10</MenuItem>
//                     <MenuItem value={20}>20</MenuItem>
//                 </Select>
//             </FormControl>
//             <Typography sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
//                 {showingFrom} - {showingTo} of {breakdown.length}
//             </Typography>
//             <IconButton onClick={() => setPage(page - 1)} disabled={page === 1} aria-label="previous page">
//                 <ArrowBackIosNewIcon sx={{ fontSize: '1rem' }} />
//             </IconButton>
//             <IconButton onClick={() => setPage(page + 1)} disabled={page === pageCount} aria-label="next page">
//                 <ArrowForwardIosIcon sx={{ fontSize: '1rem' }} />
//             </IconButton>
//         </Box>
//       </Paper>
//   );
// };

// export default CostBreakdownTable;

import React, { useState, useMemo } from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  useTheme,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  IconButton,
  Button, // Import Button
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// This is the error/empty state component you provided
const ErrorDisplay = ({ onRefresh }: { onRefresh: () => void; }) => (
  <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    p: 3,
    height: '100%',
  }}>
    <img src="/usmerror.svg" alt="Error" style={{ width: '130px', marginBottom: '16px' }} />
    <Typography variant="h6" component="h2" sx={{ fontWeight: 600, mb: 1 }}>
      Unable to Display Data
    </Typography>
    <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '300px', mb: 2 }}>
      We're having trouble loading activities right now. Please try again.
    </Typography>
    <Button
        variant="text"
        onClick={onRefresh}
        sx={{
            textTransform: 'none',
            color: '#0064FF',
            fontWeight: 500,
            fontFamily:'Inter',
            lineHeight:'21px',
            fontSize:'14px',
            mb: 10
        }}
        >
        Refresh Page
        </Button>
  </Box>
);


export interface BreakdownRow {
  group: string;
  cost: number;
  credits: number;
  discount: number;
  usage: string;
  totalCost: number;
}

export interface CostBreakdownTableProps {
  breakdown: BreakdownRow[];
  groupBy: string;
  colorMap: { [key: string]: string };
  onRefresh?: () => void; // Added optional onRefresh prop
}

const CostBreakdownTable: React.FC<CostBreakdownTableProps> = ({ breakdown, groupBy, colorMap, onRefresh }) => {
  const theme = useTheme();

  const showUsageColumn = !['Region', 'Data Sources', 'Project','Services'].includes(groupBy);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const pageCount = Math.ceil(breakdown.length / rowsPerPage);
  const paginatedData = useMemo(() => {
    const startIndex = (page - 1) * rowsPerPage;
    return breakdown.slice(startIndex, startIndex + rowsPerPage);
  }, [breakdown, page, rowsPerPage]);
  
  const showingFrom = breakdown.length > 0 ? (page - 1) * rowsPerPage + 1 : 0;
  const showingTo = Math.min(page * rowsPerPage, breakdown.length);

  const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
    setRowsPerPage(event.target.value as number);
    setPage(1);
  };
  
  // Reset page to 1 if the breakdown data changes and the current page is out of bounds
  React.useEffect(() => {
      if (page > pageCount && pageCount > 0) {
          setPage(pageCount);
      } else if (page === 0 && pageCount > 0) {
          setPage(1);
      }
  }, [breakdown, page, pageCount]);


  return (
      <Paper sx={{
        py: 2,
        borderRadius: '16px',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}>
        <Typography variant="h6" sx={{
          mb: 2,
          mt: 3,
          ml:1,
          fontWeight: 550,
          fontFamily: 'Inter',
          px: 2,
          flexShrink: 0,
          fontSize: '16px',
        }}>
          Cost Breakdown
        </Typography>

        {breakdown.length === 0 ? (
          // Show the error/empty state if there is no data
          <ErrorDisplay onRefresh={onRefresh || (() => {})} />
        ) : (
          // Otherwise, show the table and pagination
          <>
            <TableContainer sx={{
              flexGrow: 1,
              overflow: 'auto'
            }}>
              <Table
                sx={{
                  width: '100%',
                  tableLayout: 'fixed',
                  '& .MuiTableCell-root': {
                    borderBottom: 'none',
                    fontFamily: 'Inter',
                    py: '16px',
                    px: '20px'
                  }
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>{groupBy}</TableCell>
                    <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Cost</TableCell>
                    <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Credits</TableCell>
                    <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Discount</TableCell>
                    {showUsageColumn && (
                      <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Usage</TableCell>
                    )}
                    <TableCell align="right" sx={{ color: '#667085', fontSize: '12px', fontWeight: 500 }}>Total Cost</TableCell>
                    <TableCell sx={{ width: '24px', padding: 0 }} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.map((row, index) => (
                    <TableRow
                      key={`${row.group}-${index}`}
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        '&:nth-of-type(odd)': {
                            backgroundColor: '#F9FAFB',
                        },
                      }}
                    >
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: colorMap[row.group] || '#667085', flexShrink: 0 }} />
                            <Typography variant="body2" sx={{fontFamily: 'Inter', pl: '8px'}}>{row.group}</Typography>
                        </Stack>
                      </TableCell>
                      <TableCell align="right">
                        ${row.cost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                      </TableCell>
                      <TableCell align="right">${row.credits.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                      <TableCell align="right">
                        ${row.discount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                      </TableCell>
                      {showUsageColumn && (
                        <TableCell align="right">{row.usage}</TableCell>
                      )}
                      <TableCell align="right">
                        ${row.totalCost.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                      </TableCell>
                      <TableCell sx={{ padding: 0 }}/>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{
              flexShrink: 0,
              mt: 1,
              mb: 0,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 2,
              minHeight: '3.5rem',
              padding: '0 1.5rem',
              backgroundColor: '#FFFFFF',
            }}>
                <Typography sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary'  }}>
                    Rows per page:
                </Typography>
                <FormControl size="small">
                    <Select
                        value={rowsPerPage}
                        onChange={handleRowsPerPageChange}
                        sx={{
                            fontFamily: 'Inter',
                            fontSize: '0.875rem',
                            color: 'text.secondary',
                            '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                            '.MuiSelect-select': { padding: '4px 8px' },
                        }}
                    >
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                    </Select>
                </FormControl>
                <Typography sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
                    {showingFrom} - {showingTo} of {breakdown.length}
                </Typography>
                <IconButton onClick={() => setPage(page - 1)} disabled={page === 1} aria-label="previous page">
                    <ArrowBackIosNewIcon sx={{ fontSize: '1rem' }} />
                </IconButton>
                <IconButton onClick={() => setPage(page + 1)} disabled={page >= pageCount} aria-label="next page">
                    <ArrowForwardIosIcon sx={{ fontSize: '1rem' }} />
                </IconButton>
            </Box>
          </>
        )}
      </Paper>
  );
};

export default CostBreakdownTable;